import { useAppSelector } from "src/store/hooks";
import { roundDownRemainingUsage } from "src/utils/utils";

/**
 * Rounds the customer's remaining usage DOWN to the nearest `tsRemainingUsageRoundBasis`
 * (from get-ts-initial-data) for display purposes. Event logs must use the raw amount.
 *
 * Example: amount 26,157 with basis 100 → 26,100.
 */
export function useRoundedRemainingUsage(amount: number | null | undefined): number {
  const basis = useAppSelector(
    (state) => state.app.tsInitialData?.tsRemainingUsageRoundBasis
  );
  return roundDownRemainingUsage(amount, basis);
}
